import { useEffect, useState } from 'react';
import { ensureMapProviderResolved, isMapProviderResolved } from './map';

/**
 * True once the boot map-provider probe has settled. Starts true when the probe
 * already resolved (the common case: it ran during login), so there is no
 * loading flash. Otherwise flips true when the probe completes. Map components
 * gate their mount on this so the probe never blocks the rest of the app.
 */
export function useMapProviderReady(): boolean {
  const [ready, setReady] = useState(isMapProviderResolved());
  useEffect(() => {
    if (ready) return;
    let alive = true;
    ensureMapProviderResolved().then(() => {
      if (alive) setReady(true);
    });
    return () => {
      alive = false;
    };
  }, [ready]);
  return ready;
}
